const authRoutes = {
  LOGIN: '/auth/sign_in',
  LOGOUT: '/auth/sign_out',
}

export default authRoutes
